<div>
  <div class="title">
    <h2 class="primary"><span i18n="@@Move Project Folder">Move Project Folder</span>&nbsp;"{{Util.getLastItem(selectedFolder, '/')}}"</h2>
  </div>
  <!--
    `.title` used to be left unclosed here, so the whole form was
    nested INSIDE the title block and inherited its styling.
  -->
  <div>
    <form [formGroup]="changeForm" (change)="formChanged()">
      <app-folder-path [path]="selectedFolder"><ng-container i18n="@@Current Folder">Current Folder</ng-container></app-folder-path>
      <!--
        `rootLabel` makes "move this folder to the top level" reachable.

        `currentPath` is the PARENT of the folder being moved, not the folder
        itself: that folder is `excludeBranch`, so revealing it would open a
        subtree of nothing but disabled rows. Its parent is where it sits now,
        which is the context the operator needs.
      -->
      <app-tree-selector [rawData]="{'': projectFolders.getJSON()}"
                         [currentPath]="Util.getParentItem(selectedFolder, '/')"
                         rootLabel="My Projects"
                         i18n-rootLabel="@@My Projects"
                         emptyMessage="You do not have any other folders yet."
                         i18n-emptyMessage="@@treeSelectorNoOtherFolders"
                         (nodeSelected)="handleSelection($event)"
                         [excludeNode]="Util.getParentItem(selectedFolder, '/')"
                         [excludeBranch]="selectedFolder"></app-tree-selector>
<!--      <div class="folderBreadCrumbs" *ngIf="newFolderName">-->
<!--        <span i18n="@@Move Folder To">Move Folder To</span>-->
<!--        <button [disabled]="Util.getParentItem(selectedFolder, '/') === '/'" mat-flat-button matBadgeColor="primary" (click)="handleSelection('/')" color="primary" style="color: black; background: inherit; padding-right: 0px;" i18n="@@My Projects">My Projects</button>-->
<!--        <ng-container *ngFor="let folder of Util.getCumulativeStrings(newFolderName, '/')">-->
<!--          <ng-container *ngIf="folder !== '/'">-->
<!--            <mat-icon style="margin-top: 9px;">chevron_right</mat-icon>-->
<!--            <button mat-flat-button color="primary" (click)="handleSelection(folder)" color="primary"  style="color: black; background: inherit; padding-right: 0px; padding-left: 0px;">{{Util.getLastItem(folder, '/')}}</button>-->
<!--          </ng-container>-->
<!--        </ng-container>-->
<!--      </div>-->
      <div class="newFolderNotSelected" *ngIf="!newFolderName || newFolderName === selectedFolder" i18n="@@Please select a folder to move the folder to">Please select a folder to move the folder to</div>
      <div class="folderBreadCrumbs" *ngIf="newFolderName && newFolderName !== selectedFolder">
        <span i18n="@@Move Project Folder To">Move Project Folder To</span>
        <button [disabled]="Util.getParentItem(newFolderName, '/') === '/'" mat-flat-button matBadgeColor="primary" (click)="handleSelection('/')" color="primary" style="color: black; background: inherit; padding-right: 0px;" i18n="@@My Projects">My Projects</button>
        <ng-container *ngFor="let folder of Util.getCumulativeStrings(newFolderName, '/')">
          <ng-container *ngIf="folder !== '/'">
            <mat-icon style="margin-top: 9px;">chevron_right</mat-icon>
            <button mat-flat-button color="primary" (click)="handleSelection(folder)" color="primary"  style="color: black; background: inherit; padding-right: 0px; padding-left: 0px;">{{Util.getLastItem(folder, '/')}}</button>
          </ng-container>
        </ng-container>
      </div>

      <div class="folderError" *ngIf="errorMessage" i18n="@@A folder with that name already exists here.">A folder with that name already exists here.</div>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn" [disabled]="!newFolderName || newFolderName === '' || selectedFolder === newFolderName" (click)="onChange()" i18n="@@Move">Move</button>
      </div>
    </form>
  </div>
</div>
